/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_HintInputs */

const en_us2_bodymap_hint = /** @type {(inputs: Bodymap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tap the figure where it hurts, or use the list below.`)
};

const pt_br2_bodymap_hint = /** @type {(inputs: Bodymap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toque na figura onde dói, ou use a lista abaixo.`)
};

const es_419_bodymap_hint = /** @type {(inputs: Bodymap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca la figura donde te duele, o usa la lista de abajo.`)
};

const pt_pt2_bodymap_hint = /** @type {(inputs: Bodymap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toca na figura onde dói, ou usa a lista abaixo.`)
};

const fr_fr2_bodymap_hint = /** @type {(inputs: Bodymap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Touche la silhouette là où tu as mal, ou utilise la liste ci-dessous.`)
};

const de_de2_bodymap_hint = /** @type {(inputs: Bodymap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tippe auf die Stelle der Figur, die wehtut, oder nutze die Liste unten.`)
};

const it_it2_bodymap_hint = /** @type {(inputs: Bodymap_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tocca la figura dove fa male, oppure usa l'elenco qui sotto.`)
};

/**
* | output |
* | --- |
* | "Tap the figure where it hurts, or use the list below." |
*
* @param {Bodymap_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_hint = /** @type {((inputs?: Bodymap_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_hint(inputs)
	if (locale === "es-419") return es_419_bodymap_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_hint(inputs)
	if (locale === "de-DE") return de_de2_bodymap_hint(inputs)
	if (locale === "it-IT") return it_it2_bodymap_hint(inputs)
	return en_us2_bodymap_hint(inputs)
});
export { bodymap_hint as "bodymap.hint" }